import { Minus, Plus } from 'lucide-react';
import UDText from 'ud-ui/components/text';

import { DivProps } from '../../../../../typings';
import { CountButton } from './styles';

interface IProps extends DivProps {
  setValue: (value: number) => void;
  value: number;
  title?: string;
  titleWidth?: number;
}

function Counter(props: IProps) {
  const { value, setValue, title, titleWidth, className = '', ...rest } = props;

  return (
    <div className={'flex flex-row ' + className} {...rest}>
      <div className={'flex'} style={{ width: titleWidth ?? 'unset' }}>
        <UDText type={'subhead'} color={'#686A79'}>
          {title && title + ':'}
        </UDText>
      </div>
      <div className={'ml-4 flex gap-2'}>
        <CountButton onClick={() => setValue(value - 1)} icon={<Minus size={20} />} />
        <div className={'flex-center'} style={{ width: 20 }}>
          <UDText type={'subhead'} className={'fw-700'} color={'#686A79'}>
            {value}
          </UDText>
        </div>
        <CountButton onClick={() => setValue(value + 1)} icon={<Plus size={20} />} />
      </div>
    </div>
  );
}

export default Counter;
